import { Typography, Spacer } from '@telus-uds/components-web'
import { LegalTextRenderer } from '@/siteBuilder/utils/text/TextRenderer'
import ProductDetailsSection from '../PlanSection/ProductDetailsSection'
import { DEFAULTS, PlanSectionDetailFields } from '../PlanSection/PlanSection'

export type DetailsSectionProps = {
  idx: number
  sectionTitle?: string
  sectionDetails?: PlanSectionDetailFields[]
}

const DetailsSection = ({ idx, sectionTitle, sectionDetails }: DetailsSectionProps) => {
  return (
    <div key={idx}>
      {idx !== 0 && <Spacer space={2} />}
      {sectionTitle && (
        <div>
          <Typography block variant={{ size: 'h4' }} tokens={{ color: DEFAULTS.COLORS.SHUTTLE_GREY }}>
            <LegalTextRenderer>{sectionTitle}</LegalTextRenderer>
          </Typography>
          <Spacer space={2} />
        </div>
      )}
      {sectionDetails &&
        sectionDetails.map((sectionDetail, _idx) => {
          return (
            <div key={_idx}>
              <ProductDetailsSection sectionDetail={sectionDetail} IMAGE_LEFT_MARGIN={DEFAULTS.IMAGE_LEFT_MARGIN} />
            </div>
          )
        })}
    </div>
  )
}

export default DetailsSection
